// Locate2u operates this portal ("Powered by Locate2u"); the brand mark shown
// is the customer's — FedEx. This deployment is FedEx-only, so the logo is
// hardcoded rather than tenant-configurable (white-label removed 2026-07-02;
// functional settings live in portalSettings.tsx instead).
export const BRAND = {
  name: 'Locate2u Safety & Compliance',
  logoUrl: '/fedex-logo.png',
  // Reversed (light-on-dark) mark for use on the dark/purple auth brand panels.
  logoReverseUrl: '/fedex-logo-reverse.png',
  logoAlt: 'FedEx',
  supportEmail: 'compliance@locate2u.com',
} as const;
